<template>
<div class="user">
    <router-view :param="param"></router-view>
</div>
</template>

<script>
import {mapActions} from 'vuex'
import {initPage} from 'common/js/mixin'

export default {
    name: 'user',
    mixins: [initPage],
    data() {
        return {
            param: {
                eventinnerid: '',
                keywords: '',
                chname: '',
                isheader: '',
                title: ''
            }
        }
    },
    mounted() {
        this.setParams(this._.cloneDeep(this.param))
    },
    methods: {
        ...mapActions([
            'setParams'
        ])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.user {
}
</style>
